import { render, staticRenderFns } from "./FormOrder.vue?vue&type=template&id=ec0533b2&scoped=true&"
import script from "./FormOrder.vue?vue&type=script&lang=js&"
export * from "./FormOrder.vue?vue&type=script&lang=js&"
import style0 from "./FormOrder.vue?vue&type=style&index=0&id=ec0533b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0533b2",
  null
  
)

export default component.exports